import React, { useContext } from 'react'
import './FoodItem.css'
import { assets } from '../../assets/frontend_assets/assets'
import { storeContext } from '../../Context/storeContext';
const FoodItem = ({id,name,description,image,price}) => {

    const {cartItem,addToCart,removeFromCart}=useContext(storeContext)
  return (
    <div className='food-item'>
        <div className='food-item-img-container'>
            <img alt='' src={image} className='food-item-image'/>
            {!cartItem[id] 
              ?<img className='add' alt='' onClick={()=>addToCart(id)} src={assets.add_icon_white} />
              :<div className='food-item-counter'>
                <img alt='' onClick={()=>removeFromCart(id)} src={assets.remove_icon_red} />
                <p>{cartItem[id]}</p>
                <img alt='' onClick={()=>addToCart(id)} src={assets.add_icon_green} />
                
               </div>

            }

        </div>
        <div className='food-item-info'>
            <div className='food-item-name-rating'>
                <p>{name}</p>
                <img alt='' src= {assets.rating_starts}></img>
            </div>
            <p className='food-item-desc'>{description}</p>
            <p className='food-item-price'>${price}</p>
        </div>
      
    </div>
  )
}

export default FoodItem
